import { render } from "./FilmChecklist.vue?vue&type=template&id=652059c8"
import script from "./FilmChecklist.vue?vue&type=script&lang=js"
export * from "./FilmChecklist.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__